/// <amd-module name="typeahead/client/MercuryWizardHandler" />
/// <amd-dependency path="jquery" name="$"/>
/// <reference path="../../typings/thirdparty/jquery/jquery.d.ts" />
import {ClientHandlerRegistry, IClientHandler, ILobData} from "typeahead/client/ClientHandlerRegistry";
import {GeolocationDataProvider} from "typeahead/core/geolocation/GeolocationDataProvider";
import {GeolocationViewController} from "typeahead/core/geolocation/GeolocationViewController";
import {MercuryGeolocationViewController} from "typeahead/core/geolocation/MercuryGeolocationViewController";
import {FormLoadedMessage} from "typeahead/core/message/FormLoadedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class MercuryWizardHandler implements IClientHandler {
    private static readonly APPLICABLE_CLIENT_IDS = [
        "Homepage",
        "AWSHomepage",
        "LXLandingPage",
        "CarsLandingPage",
        "FlightsLandingPage",
        "HotelsLandingPage",
        "PackageLandingPage",
        "RailsLandingPage",
    ];

    private geolocationViewController: GeolocationViewController;

    constructor() {
        // This fixes the caching issue when switching between package types
        uitk.subscribe("sfSelectedLobs.updated", (topic: string, lob: ILobData) => {
            if (["flightHotel", "flightHotelCar"].indexOf(lob.searchSubType) > -1) {
                $("input[data-provide=utypeahead]").removeData("typeahead");
            }
        });
    }

    public isApplicable(clientId: string): boolean {
        return MercuryWizardHandler.APPLICABLE_CLIENT_IDS.indexOf(clientId) > -1;
    }

    public subscribeFormSubmitEvent(): void {
        const sfLobUpdatedHandler = () => {
            $("form").off("click.typeahead").on("click.typeahead", "button[type=submit]", (event) => {
                if ($(event.target).parents("form:has(input[data-provide=utypeahead])").length > 0) {
                    ClientHandlerRegistry.publishSubmitClickedMessage(null, event);
                }
            });
            // set this submit handler to execute after mercury submit handler
            setTimeout(() => {
                $("form:has(input[data-provide=utypeahead])").off("submit.typeahead").on("submit.typeahead",
                (event) => {
                    const isFormValid = (): boolean => {
                        const validationElement =
                            $("form:has(input[data-provide=utypeahead]):visible .validation-alert");
                        return validationElement.is(":hidden") || validationElement.hasClass("visuallyhidden");
                    };
                    ClientHandlerRegistry.publishFormSubmittedMessage(isFormValid(), event);
                });
            }, 0);
        };
        uitk.subscribe("sfSelectedLobs.updated", () => {
            sfLobUpdatedHandler();
        });
        sfLobUpdatedHandler();
    }

    public subscribeFormLoadedEvent(): void {
        const publishFormLoadedMessage = () => {
            TypeaheadMessage.publish(
                new FormLoadedMessage(this.getTab()));
        };
        publishFormLoadedMessage(); // On Page Load
        uitk.subscribe("mercury-form-history-loaded", () => {
            publishFormLoadedMessage(); // On tab change
        });
    }

    public getTab(): string {
        return $("li.tab:visible").children("button.on").data("lob");
    }

    public getGeolocationViewController(geolocationDataProvider: GeolocationDataProvider): GeolocationViewController {
        if (!this.geolocationViewController) {
            this.geolocationViewController = new MercuryGeolocationViewController(geolocationDataProvider);
        }
        return this.geolocationViewController;
    }
}
